import React from 'react';
import _ from 'lodash';

import { Confirmation } from './common';
import { UpdatePartnerCompanyBranchWorkersTable } from '../tables/UpdatePartnerCompanyBranchWorkersTable';
import { messageUtility } from '../../utilities/messageUtility';
import {
  HEAD_OFFICE_OPTION,
  PartnerCompanyBranchDropdown,
} from '../PartnerCompanyBranchDropdown';

export class UpdatePartnerCompanyBranchWorkersDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      params: {
        partner_company_branch_id: null,
      },
    };
    this.fixedOptions = [HEAD_OFFICE_OPTION];
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setParam('partner_company_branch_id', null);
    }
  }

  setParam = (name, id) => {
    const _params = { ...this.state.params };
    _params[name] = id;
    this.setState({ params: _params });
  };

  handleSelectPartnerCompanyBranch = id => {
    this.setParam('partner_company_branch_id', id);
  };

  onCancel = () => {
    this.props.onCancel();
  };

  onSubmit = () => {
    this.props.onConfirm(this.state.params);
  };

  generateDialogContent = () => {
    return (
      <React.Fragment>
        <div>
          {_.size(this.props.workers)}
          名の作業員の支店を変更します。変更先の支店を選択してください。
        </div>
        <div className='dialog-form'>
          <div className='search-form__item'>
            <div className='dialog-form__label'>
              <span className='label'>支店</span>
            </div>

            <div className='dialog-form__element'>
              <div className='drop-down-list-wrap'>
                <PartnerCompanyBranchDropdown
                  selectedCompanyId={this.props.selectedCompanyId}
                  selectedPartnerCompanyBranchId={
                    this.state.params.partner_company_branch_id
                  }
                  onSelect={this.handleSelectPartnerCompanyBranch}
                  fixedOptions={this.fixedOptions}
                />
              </div>
            </div>
          </div>
        </div>

        <div className='UpdatePartnerCompanyBranchWorkersDialog__wrap-table'>
          <UpdatePartnerCompanyBranchWorkersTable
            workers={this.props.workers}
          />
        </div>
      </React.Fragment>
    );
  };

  render() {
    return (
      <Confirmation
        visible={this.props.visible}
        title='支店の一括変更'
        message={this.generateDialogContent()}
        rootClassName='UpdatePartnerCompanyBranchWorkersDialog'
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        confirmButtonText={messageUtility.getMessage('I-000-088')}
        onCancel={this.onCancel}
        onConfirm={this.onSubmit}
        disabledConfirmButton={!this.state.params.partner_company_branch_id}
        effectiveButtonClassName={
          this.state.params.partner_company_branch_id
            ? 'btn--effective'
            : 'btn--disabled'
        }
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/UpdatePartnerCompanyBranchWorkersDialog.jsx